import { Box, Brand, BODY_INK, CroppedImage, INK, LogoAt, Page, pt, Text } from "../primitives";
/**
 * «المشروع» and «ترتيب اللوحات المقترح» pages (Arabic master template,
 * pages 14 / 15 / 17). The employee fills data.project:
 *   { name, description, photo: slot, artType, artTypeDescription, arrangement: slot }
 * Empty values keep the page as the template shows it (black photo panel).
 */
const LINE = 29; // pt between paragraph lines in the reference

// photo panel on the left (black until an image is uploaded)
function PhotoPanel({ slot, w }) {
    return (<Box x={0} y={0} w={w} h={810} style={{ background: "#000000", overflow: "hidden" }}>
      {slot?.image && <CroppedImage image={slot.image} crop={slot.crop} w={w} h={810}/>}
    </Box>);
}
function Paragraph({ text, right, top, width }) {
    if (!text)
        return null;
    return (<Text right={right} top={top} size={17.4} weight={300} color={BODY_INK} width={width} wrap style={{ lineHeight: pt(LINE), whiteSpace: "pre-line" }}>
      {text}
    </Text>);
}

/** Page 14 — dark page with the project name. */
export function ProjectTitlePage({ project }) {
    return (<Page background={INK}>
      <LogoAt cx={73} cy={90} w={31} color="#ffffff"/>
      <Brand right={1064.4} top={63} size={33.4} color="#ffffff"/>
      {project.name && (<Text left={105.5} top={616} size={42.8} weight={700} color="#ffffff">
          {project.name}
        </Text>)}
    </Page>);
}

/** Page 15 — project photo + name + description. */
export function ProjectPage({ project }) {
    return (<Page>
      <PhotoPanel slot={project.photo} w={561}/>
      <LogoAt cx={73} cy={90} w={31} color="#ffffff"/>
      <Brand right={1064.4} top={63} size={33.4}/>
      <Text right={1065.2} top={481.4} size={17.4} weight={700} color={INK}>
        {project.name}
      </Text>
      <Paragraph text={project.description} right={1065.2} top={530} width={458}/>
    </Page>);
}

/** Page 17 — suggested arrangement: image + art type + description. */
export function ArrangementPage({ project }) {
    return (<Page>
      <PhotoPanel slot={project.arrangement} w={590}/>
      <Brand right={1064.4} top={63} size={33.4}/>
      <Text right={1065.2} top={485.1} size={17.4} weight={700} color={INK}>
        {project.artType || "نوع الرسم"}
      </Text>
      <Paragraph text={project.artTypeDescription} right={1065.2} top={533.6} width={426}/>
    </Page>);
}
